var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 28.8V25.2H39.6V28.8H36Z",
    fill: "#FA6613"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 1.51562L50.4 15.1668V38.8332L27 52.488L3.6 38.8332V15.1668L27 1.51562ZM22.7952 14.4C19.6139 14.4 16.5628 15.6638 14.3133 17.9133C12.0638 20.1629 10.8 23.2139 10.8 26.3952V27.6048C10.8005 29.6489 11.3233 31.6589 12.3188 33.4441C13.3143 35.2293 14.7496 36.7305 16.4882 37.8053C18.2269 38.88 20.2114 39.4926 22.2534 39.5849C24.2953 39.6773 26.327 39.2463 28.1556 38.3328L29.6064 37.6128L27.9936 34.3908L26.5464 35.1108C25.2672 35.7509 23.8456 36.0533 22.4166 35.9893C20.9877 35.9254 19.5987 35.4973 18.3818 34.7456C17.1648 33.994 16.1602 32.9437 15.4633 31.6945C14.7664 30.4454 14.4004 29.0388 14.4 27.6084V26.3988C14.4002 24.9682 14.7659 23.5613 15.4625 22.3118C16.1592 21.0622 17.1636 20.0114 18.3804 19.2591C19.5973 18.5067 20.9862 18.0779 22.4154 18.0131C23.8445 17.9484 25.2665 18.25 26.5464 18.8892L27.9936 19.6128L29.6064 16.3944L28.1556 15.6708C26.4905 14.8366 24.6576 14.4015 22.7952 14.4ZM32.4 18V21.6H28.8V25.2H32.4V28.8H28.8V32.4H32.4V36H36V32.4H39.6V36H43.2V32.4H46.8V28.8H43.2V25.2H46.8V21.6H43.2V18H39.6V21.6H36V18H32.4Z",
    fill: "#FA6613"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsharp);
export default __webpack_public_path__ + "static/media/csharp.97475ceb10fa525243bb14bb1d129ded.svg";
export { ForwardRef as ReactComponent };